import { ChangeEvent, ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

interface Props {
    id: string;
    checked: boolean;
    children: ReactNode;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function ClientSwitcherOption({ id, checked, children, onChange }: Props) {
    return (
        <label
            key={id}
            htmlFor={`radio-clientId-${id}`}
            className={twJoin(
                'flex flex-grow cursor-pointer items-center justify-start',
                'gap-2.5 whitespace-nowrap rounded bg-white px-4 py-2.5',
                'has-[:checked]:bg-primary-200',
                !checked && 'hover:bg-neutral-100',
            )}
            aria-checked={checked}>
            <div
                className={twJoin(
                    'relative flex size-5 shrink-0 items-center justify-center',
                    'rounded-full border border-neutral-400 bg-white',
                    'has-[:checked]:border-primary-500',
                )}>
                <input
                    id={`radio-clientId-${id}`}
                    name="clientId"
                    type="radio"
                    className="peer absolute min-w-0 appearance-none"
                    value={id}
                    defaultChecked={checked}
                    onChange={onChange}
                    tabIndex={-1}
                />
                <div className="size-2 rounded-full peer-checked:bg-primary-500"></div>
            </div>
            <div className="text-wrap">{children}</div>
        </label>
    );
}
